import moment from 'moment-timezone'
import Base from '@/resources/Base'
import IQCollection from '@/resources/collections/IQCollection'
import { DATETIME_FORMAT, DATETIME_STATS_DISPLAY_FORMAT } from '@/constants/datetime.constants'

export default class Anomalies extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.tableResultAccessor = 'newLoginDrillDownResult.userLoginInfoList'
    this.chartResultAccessor = 'loginAnomalyView.loginDailySummary.loginDataPoints'
    this.chartData = {
      labels: [],
      datasets: [],
      chartOptions: {}
    }
    this.collection = {}
    this.columns = []
  }

  /**
   * "drillDownResult": {
        "description": null,
        "drillDownTemplate": null,
        "loginAnomalyView": null,
        "newLoginDrillDownResult": {
            "userLoginInfoList": [
                {
                    "agentId": null,
                    "city": null,
                    "country": null,
                    "srcAddr": "fe80::39f8:dc41:8bd5:32b1",
                    "timestamp": 1626972440068839000,
                    "userName": "Administrator"
                }
            ]
        },
        "potentialImpact": null,
        "recommendation": null
    }
   */
  buildTableData (stats) {
    let data = _.get(stats, this.tableResultAccessor)
    this.createTableCol(data[0])
    data.forEach(record => {
      if (!_.isEmpty(record.agentId)) {
        let hostfound = _.find(this.options.hosts, {
          agentNumber: record.agentId
        })
        if (hostfound) {
          record.agentId = hostfound.customHostname
        }
      }
    })
    this.collection = new IQCollection(data, { attributes: this.columns })
  }

  buildChartData (stats) {
    let data = _.get(stats, this.chartResultAccessor)
    let chartPlots = _.sortBy(data, 'timestamp')
    this.chartData.labels = _.map(chartPlots, plot => {
      let timeformated = plot.timestamp * 1000 // convert secs to millisecs
      return moment(timeformated).format(DATETIME_STATS_DISPLAY_FORMAT)
    })
    this.chartData.datasets = [
      {
        label: 'Login Success',
        backgroundColor: 'lightblue',
        borderColor: 'blue',
        borderWidth: 1,
        data: _.map(chartPlots, 'successCount'),
        stats: chartPlots
      },
      {
        label: 'Login Failure',
        backgroundColor: '#fdbdca',
        borderColor: '#ee3354',
        borderWidth: 1,
        data: _.map(chartPlots, 'failureCount'),
        stats: chartPlots
      }
    ]
    this.chartData.chartOptions = {
      title: {
        display: true,
        text: 'Login Anomalies'
      }
    }
  }

  getColumnLabel (key) {
    switch (key) {
      case 'agentId':
        return 'Host'
      case 'ip':
        return 'IP'
      case 'city':
        return 'City'
      case 'country':
        return 'Country'
      case 'destAddr':
        return 'Dest IP'
      case 'srcAddr':
        return 'Source IP'
      case 'timestamp':
        return 'Time'
      case 'userName':
        return 'User'
      case 'failureCount':
        return 'Failure Count'
      case 'successCount':
        return 'Success Count'
      case 'priorFailureRate':
        return 'Past Month Failure Rate'
      case 'peakDailyFailureRate':
        return 'Peak Failure Rate'
      case 'execution':
        return 'Execution'
    }
  }

  createTableCol (record) {
    this.columns.length = 0
    for (let key in record) {
      if (record[key]) {
        let col = {
          datatype: 'string',
          description: this.getColumnLabel(key),
          label: this.getColumnLabel(key),
          name: key,
          'min-width': 150,
          sortable: true
        }
        if (key === 'timestamp') {
          col.datatype = 'datetime'
          col.format = DATETIME_FORMAT
        }
        this.columns.push(col)
      }
    }
  }

  setLabelHostnames (hosts) {
    this.chartData.labels.forEach((label, idx) => {
      let hostnameIdx = _.findIndex(hosts, { agentId: label })
      // if agentId is found, use hostname instead for friendly labeling
      if (hostnameIdx > -1) {
        this.chartData.labels[idx] = hosts[hostnameIdx].customHostname
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/anomalies/Anomalies.js